import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from "@angular/core";
import {UserData} from "../../auth/user.data";
import {PageComponent} from "../../page/page.component";

@Component({
    selector: "fhm-search-page",
    templateUrl: "./search-page.component.html",
    styleUrls: ["./search-page.component.scss"],
    standalone: false
})
export class SearchPageComponent implements OnChanges {

    @ViewChild(PageComponent) pageComponent: PageComponent;

    @Output() serviceSelection: EventEmitter<string> = new EventEmitter<string>();

    @Input() showColumnSearch: boolean = true;

    @Input() type: string;

    @Input() gridData: any[] = [];

    @Input() styleColumnFn: (columnName: string, record: any) => any;

    @Input() valueColumnFn: (columnName: string, record: any) => any;

    /**
     * Indicates if the first column is clickable link
     */
    @Input() showLink: boolean;

    @Input() showAdd: boolean;

    @Input() showRefresh: boolean;

    @Input() showDelete: boolean;

    @Input() showDeleteFunc: (record: any) => boolean;

    @Input() showRecontinueFunc: (record: any) => boolean;

    @Input() showDownloadReport: boolean;

    @Input() columns: string[];

    @Input() user: UserData;

    @Input() sortableColumns: string[];

    @Input() paging: boolean = false;

    /**
     * Emits a selected record
     * @type {EventEmitter<any>}
     */
    @Output() selectRecord: EventEmitter<any> = new EventEmitter<any>();

    @Output() deleteRecord: EventEmitter<any> = new EventEmitter<any>();

    @Output() recontinueRecord: EventEmitter<any> = new EventEmitter<any>();

    @Output() downloadReport: EventEmitter<any> = new EventEmitter<any>();

    @Output() addNew: EventEmitter<any> = new EventEmitter<any>();

    @Output() refresh: EventEmitter<any> = new EventEmitter<any>();

    @Output() columnSorted: EventEmitter<{ column: string, ascend: boolean }> = new EventEmitter<{ column: string; ascend: boolean }>();

    @Output() linkColumnClicked: EventEmitter<any> = new EventEmitter<any>();

    gridView: any[] = [];
    pageIndex: number = 0;
    pageSize: number = 100;
    totalPages: number;
    totalRecords: number;
    totalRecordsOnPage: number;

    filterName: string;

    nameSearchChanged(name: string) {
        this.filterName = name;
        this.updateView();
    }

    refreshData(): void {
        this.pageComponent.clearFilter();
        this.filterName = undefined;
        this.refresh.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["gridData"]) {
            this.updateView();
        }
    }

    updateView(): void {
        const data: any[] = this.gridDataView;
        if (this.paging) {
            this.totalRecords = data.length;
            this.totalPages = Math.ceil(data.length / this.pageSize);
            this.pageIndex = this.pageIndex > this.totalPages ? 0 : this.pageIndex;
            this.goToPage(this.pageIndex);
        } else {
            this.gridView = data;
        }
    }

    get gridDataView(): any[] {
        if (this.filterName) {
            return this.gridData.filter((record: any) => {
                    if (record[this.columns[0]] && record[this.columns[0]].indexOf(this.filterName.toLowerCase()) === -1) {
                        return false;
                    } else {
                        return true;
                    }
                }
            );
        } else {
            return this.gridData;
        }
    }

    goToPage(page: number): void {
        this.pageIndex = page;
        if (this.pageIndex > this.totalPages) {
            this.pageIndex = this.totalPages;
        } else if (this.pageIndex < 0) {
            this.pageIndex = 0;
        }
        const recordStart: number = this.pageIndex * this.pageSize;
        this.gridView = this.gridDataView.slice(recordStart, recordStart + this.pageSize);
        if ((recordStart + this.pageSize) > this.totalRecords) {
            this.totalRecordsOnPage = this.totalRecords;
        } else {
            this.totalRecordsOnPage = recordStart + this.pageSize;
        }
    }
}
